import type { ActivationDeviceId, SigningMethodRequest, SigningMethodResponse } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get, post } from './request';

const SERVICE_PATH = `${CONTEXT_PATH}/rest/resource/signingmethod`;

export const getSigningMethod = async (deviceId: ActivationDeviceId): Promise<SigningMethodResponse> =>
    get(`${SERVICE_PATH}/${deviceId.value}`);
export const saveSigningMethod = async (deviceId: ActivationDeviceId, request: SigningMethodRequest) =>
    post<void>(`${SERVICE_PATH}/${deviceId.value}`, request);
